// BUNDLED: pdp-bundle.js
export default function() {
	jQuery(function ($) {
		Handlebars.registerPartial('EnhancedPDP-ProductConfiguration', $("#ProductDetail-ProductConfiguration-Enhanced").html());
		Handlebars.registerPartial('ProductDetails-Header', $("#ProductDetails-Header").html());
		Handlebars.registerHelper('getCloudinaryURI', function (uri, type) {
			if (!CCRZ.cloudinaryRegex) {
				CCRZ.cloudinaryRegex = new RegExp('\.*(\\/upload)(.*?)(\\/v\\d*).*','d');
			}
			const results = CCRZ.cloudinaryRegex.exec(uri);
			if (!results) return uri;

			let newUrl = uri.substring(0, results.indices[1][1]);
			newUrl += '/' + CCRZ.cloudinaryTransforms[type] || '';
			newUrl += uri.substring(results.indices[3][0], uri.length);
			return newUrl;
		});
	});
}
